import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String
  }

  static targets = ["spinner", "statusLabel"]

  static STATUSES = {
    NEW: "new",
    READY: "ready",
    INFERRING: "inferring",
    FAILED: "failed"
  }

  static VALID_STATUSES = Object.values(this.STATUSES)

  connect() {
    this.checkStatusAndMaybePoll()
  }

  disconnect() {
    this.stopPolling()
  }

  async checkStatusAndMaybePoll() {
    try {
      const result = await this.fetchStatus()
      this.validateStatus(result.status)
      this.updateUI(result)

      if ([this.constructor.STATUSES.NEW, this.constructor.STATUSES.INFERRING].includes(result.status)) {
        this.startPolling()
      }
    } catch (error) {
      Sentry.captureException(error)
      console.error("Initial source menu check failed:", error)
    }
  }

  startPolling() {
    if (!this.polling) {
      this.polling = setInterval(() => this.checkStatus(), 10000)
    }
  }

  stopPolling() {
    if (this.polling) {
      clearInterval(this.polling)
      this.polling = null
    }
  }

  async checkStatus() {
    try {
      const result = await this.fetchStatus()
      this.validateStatus(result.status)
      this.updateUI(result)
    } catch (error) {
      Sentry.captureException(error)
      console.error("Polling source menu check failed:", error)
    }
  }

  async fetchStatus() {
    const response = await fetch(this.urlValue, {
      headers: { Accept: "application/json" }
    })

    if (!response.ok) throw new Error("Source menu status request failed")

    const data = await response.json()
    return data
  }

  validateStatus(status) {
    if (!this.constructor.VALID_STATUSES.includes(status)) {
      throw new Error(`Invalid source menu status: "${status}"`)
    }
  }

  updateUI(result) {
    this.updateSpinnerVisibility(result.status)

    if (this.hasStatusLabelTarget) {
      this.statusLabelTarget.textContent = result.label
    }

    const { READY, FAILED } = this.constructor.STATUSES
    if ([READY, FAILED].includes(result.status)) {
      this.stopPolling()
    }
  }

  updateSpinnerVisibility(status) {
    if (!this.hasSpinnerTarget) return

    const { INFERRING, NEW } = this.constructor.STATUSES
    const showSpinner = status === INFERRING || status === NEW

    this.spinnerTarget.classList.toggle("hidden", !showSpinner)
  }
}
